import { useMemo } from 'react';
import { useGlobalStore } from '@digiwedge/global-state';
import { usePermissions } from '../../app/rbac/usePermissions.js';

export function useAuth() {
  const token = useGlobalStore((s) => s.token);
  const { claims } = usePermissions();
  const scopes = useMemo(() => {
    const raw = claims.scope ?? '';
    return raw.split(/\s+/).filter(Boolean);
  }, [claims.scope]);
  return { token, scopes } as const;
}
